<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <tenant-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></tenant-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusName"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            border
        >
            <template v-slot:cusName="{ row }">
                <Icon
                    custom=" iconfont iconfont-weixin"
                    size="24"
                    style="color: #46bb36"
                    v-if="row.wxUserId"
                />
                <Icon
                    custom=" iconfont iconfont-weixin"
                    size="24"
                    style="color: #dddddd"
                    v-else
                />
                {{ row.cusName }}
                <div>
                    <Button
                        v-if="row.wxUserId && $can('update')"
                        type="default"
                        size="small"
                        style="margin: 5px 0px"
                        @click="rowClickUnBind(row)"
                    >
                        解除绑定
                    </Button>
                    <Button
                        v-if="!row.wxUserId && $can('update')"
                        type="default"
                        size="small"
                        style="margin: 5px 0px"
                        @click="rowClickToBind(row)"
                    >
                        邀请绑定
                    </Button>
                </div>
            </template>
            <template v-slot:billStatusText="{ row }">
                <tag-status
                    :text="row.billStatusText"
                    :color="row.billStatusColor"
                    :background="row.billStatusBgc"
                    circle
                />
            </template>

            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <!-- <Button
                    v-if="row.wxUserId && $can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUnBind(row)"
                >
                    解除绑定
                </Button>
                <Button
                    v-if="!row.wxUserId && $can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickToBind(row)"
                >
                    邀请绑定
                </Button> -->
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickreminder(row)"
                >
                    提醒
                </Button>
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="reminderRecord(row)"
                >
                    提醒记录
                </Button>
                <Dropdown
                    transfer
                    @on-click="
                        (name) => {
                            changeAction(name, row)
                        }
                    "
                >
                    <Button type="default" size="small">更多</Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="contractView" v-if="$can('view')">
                            查看合同
                        </DropdownItem>
                        <DropdownItem name="billView" v-if="$can('view')">
                            查看账单
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出框-提示 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <!-- 提示信息——解除绑定 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowUnBind"
            :id="curId"
            @closeModal="closeModalUnBind"
            @confirmModal="confirmModalUnBind"
        />
        <!-- 弹出层——生成二维码 -->
        <create-qrcode
            v-model="modal.showCreateQrcode"
            @input="closeCreateQrcode"
            :id="user.cusId"
            :cusName="user.cusName"
            :houseName="user.houseName"
        />
        <smart-modal
            v-model="modal.showRemindRecordForm"
            title="提醒记录"
            :width="900"
            :height="600"
            :maskClosable="false"
            :buttons="[{ type: 'default', text: '关闭', name: 'cancel' }]"
        >
            <remind-record-form
                v-if="modal.showRemindRecordForm"
                :cusId="curId"
                :houseId="houseId"
                :cusName="cusName"
                :cusMobile="cusMobile"
                :houseName="houseName"
                :totalPeriod="totalPeriod"
            />
        </smart-modal>

        <smart-modal
            v-model="modal.showSendRemindForm"
            title="发送提醒"
            :width="900"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <send-remind-form v-if="modal.showSendRemindForm" :row="row" />
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency, groupBy } from '_u/helper'
import Dict from '_u/dict'

import mTenantList from '_v/common/m-tenant-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import Alter from '_v/components/alter'
import Confirm from '_v/components/confirm'
import CreateQrcode from './create-qrcode'
import RemindRecordForm from './remind-record-form'
import SendRemindForm from './send-remind-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { tenantsList, tenantsUnBind } from '@/api/tenants'

export default {
    name: 't-rent-list',
    mixins: [mTenantList],
    components: {
        SelectRoom,
        TagStatus,
        Alter,
        Confirm,
        CreateQrcode,
        RemindRecordForm,
        SendRemindForm,
        FilterDateRange,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: '',
            cusName: '',
            cusMobile: '',
            houseName: '',
            totalPeriod: '',
            houseId: '',
            row: {},
            period: '',
            user: {},
            page: {
                total: 0,
                list: [],
            },
            modalMsg: '',
            alterShow: false,
            confirmShowUnBind: false,
            modal: {
                showCreateQrcode: false,
                showRemindRecordForm: false,
                showSendRemindForm: false,
            },
            dict: {
                billStatus: Dict.NULL,
                contractStatus: Dict.NULL,
            },
            contractStatusList: [],
        }
    },

    computed: {
        ...mapCache({
            filter: 'rentFilter',
            advFilter: 'rentAdvFilter',
            advOptions: 'rentAdvOptions',
            selectRoom: 'rentSelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 70,
                },

                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 150,
                    slot: 'cusName',
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 180,
                    tooltip: true,
                },
                {
                    key: 'contractStart2End',
                    title: '合同起止',
                    align: 'center',
                    minWidth: 185,
                    tooltip: true,
                },
                {
                    key: 'contractStatusText',
                    title: '租客状态',
                    align: 'center',
                    width: 120,
                },
                {
                    key: 'periodText',
                    title: '当前账期',
                    align: 'center',
                    minWidth: 240,
                },
                {
                    key: 'billStatusText',
                    title: '当期交费状态',
                    align: 'center',
                    width: 120,
                    slot: 'billStatusText',
                },
                {
                    key: 'receivedCount',
                    title: '已交期数',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'totalPeriod',
                    title: '总期数',
                    align: 'center',
                    minWidth: 100,
                },
                {
                    key: 'planDate',
                    title: '应付款日',
                    align: 'center',
                    width: 120,
                },
                {
                    key: 'rent',
                    title: '租金(元/月)',
                    align: 'right',
                    width: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 200,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        billStatusList() {
            var filterList = this.dict.billStatus
                .toList()
                .filter((v) => v.id == '1' || v.id == '2' || v.id == '5')
            var list = filterList || []
            return list
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                tenantsList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
                Dict.get(['bill_status', 'contract_status']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    const billStatusDict = this.dict.billStatus,
                        contractStatusDict = this.dict.contractStatus
                    view.data.page.list.forEach((v) => {
                        v.periodText = `第${v.period}期(${v.startDate} 至 ${v.endDate})`
                        v.contractStart2End = `${v.contractStartDate} 至 ${v.contractEndDate}`
                        v.rent = currency(v.rent / 100)
                        v.receivedCount += '期'
                        v.totalPeriod += '期'
                        v.contractStatusText = contractStatusDict.val(
                            v.contractStatus
                        )
                        const status = billStatusDict.get(v.billStatus)
                        if (status) {
                            status.remark = JSON.parse(status.remark)
                            v.billStatusText = status.text
                            v.billStatusColor = status.remark.color
                            v.billStatusBgc = status.remark.background
                        } else {
                            v.billStatusText = ''
                        }
                    })
                    this.setPageData(view.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            data.page.list.forEach((v) => {
                v.groupByText = v.cusId + v.cusName
            })
            var list = []
            Object.values(groupBy(data.page.list, 'groupByText')).forEach(
                (g) => {
                    var first = g[0]

                    first._merge = {
                        cusName: {
                            rowspan: g.length,
                        },
                        cusMobile: {
                            rowspan: g.length,
                        },
                    }

                    list.push(...g)
                }
            )
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        // 导出Excel
        onClickExport() {
            this.$refs.mt.exportToExcel()
        },
        // 解除绑定
        rowClickUnBind(row) {
            this.modalMsg = '解除绑定后租客将无法查看账单，是否确定？'
            this.confirmShowUnBind = true
            this.curId = row.cusId
        },
        closeModalUnBind() {
            this.confirmShowUnBind = false
        },
        confirmModalUnBind(id) {
            tenantsUnBind(id)
                .then(() => {
                    this.$Message.success('解除绑定成功')
                })
                .catch(() => {
                    this.$Message.error('解除绑定失败')
                })
                .finally(() => {
                    this.confirmShowUnBind = false
                    this.fetch()
                })
        },
        // 邀请绑定
        rowClickToBind(row) {
            this.user = row
            this.modal.showCreateQrcode = true
        },
        closeCreateQrcode() {
            this.modal.showCreateQrcode = false
        },
        // 发送提醒
        rowClickreminder(row) {
            if (row.wxUserId) {
                this.row = row
                this.modal.showSendRemindForm = true
            } else {
                this.modalMsg = '该租客未绑定微信，请先邀请绑定再发送提醒'
                this.alterShow = true
            }
        },
        // 更多
        changeAction(name, row) {
            this[name](row)
        },
        // 提醒记录
        reminderRecord(row) {
            this.curId = row.cusId
            this.houseId = row.houseId
            this.cusName = row.cusName
            this.cusMobile = row.cusMobile
            this.houseName = row.houseName
            this.totalPeriod = row.totalPeriod
            this.modal.showRemindRecordForm = true
        },
        // 查看合同
        contractView(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.contractId, type: '5' },
            })
        },
        // 查看账单
        billView(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: {
                    contractId: row.contractId,
                    type: '5',
                    tabItem: 'contractViewBill',
                },
            })
        },
        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
    },
}
</script>
<style lang="less" scoped></style>
